export const constants = {
  MFE_SCRAP_NAME: 'scrap',
  MFE_EXPOSED_PATH: './ScrapApp',
};
